import { JsonApiDecorator } from '@everfi/reactifi/src/json-api/JsonApiDecorator';

export default function mapStateToProps(state, ownProps) {
  const props = { ...ownProps };
  const apiStore = new JsonApiDecorator(state.api);
  const { programs, gateways } = apiStore;

  props.program = programs ? programs.first('account') : null;
  props.gateways = gateways ? gateways.all() : [];

  return props;
}
